import { fonts } from "../ticketLayout";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 0.25,
    minWidth: 0,
    py: 0.5,
    // O botão de copiar só aparece quando o cursor entra no campo.
    "&:hover .campo-copiar": { opacity: 1 },
  },
  rotulo: {
    fontSize: fonts.chip,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
  },
  linhaValor: {
    display: "flex",
    alignItems: "flex-start",
    gap: 0.5,
    minWidth: 0,
  },
  valor: {
    fontSize: fonts.body,
    lineHeight: 1.45,
    wordBreak: "break-word",
    minWidth: 0,
    flex: 1,
  },
  boxCopiar: {
    // No toque não há hover, então o botão fica sempre visível abaixo de md.
    opacity: { xs: 1, md: 0 },
    transition: "opacity 0.15s ease-in-out",
    flexShrink: 0,
    mt: "-4px",
  },
});

export default styles;
